import { OctagonX, X } from "lucide-react";

type ErrorMessageProps = {
  error: string;
  onDismiss: () => void;
  className?: string;
};

export const ErrorMessage = ({ error, onDismiss, className = "m-6 mb-0" }: ErrorMessageProps) => (
  <div className={`rounded-lg border border-red-200 bg-red-50 p-4 ${className}`}>
    <div className="flex items-center gap-3">
      <div className="flex-shrink-0">
        <OctagonX className="h-5 w-5 text-red-700" />
      </div>

      <div className="flex-1 self-center">
        <p className="m-0! text-sm text-red-700">{error}</p>
      </div>

      <div className="flex-shrink-0">
        <button
          data-testid="error-dismiss-button"
          onClick={onDismiss}
          className="rounded-md p-1 text-red-400 transition-colors hover:bg-red-100 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          aria-label="Dismiss error"
          title="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  </div>
);
